export default __webpack_public_path__ + "static/miljo2022-6-2-7d4cf130f15eaff9b0f57500c779fdbe.jpg";